import {FileDTO} from '../model/ServiceRequest'
import {BlockBlobClient} from '@azure/storage-blob'
import FileSaver from 'file-saver'

export const uploadServiceRequestFileToBlobStorage = async (fileDTO: FileDTO | null, file: File) => {
    // if no file, don't try to upload it
    if (!fileDTO?.uri) return

    // upload file on storage account
    const blockBlobClient = new BlockBlobClient(fileDTO.uri)
    const arrayBufferFile = await file.arrayBuffer()
    await blockBlobClient.uploadData(arrayBufferFile)
}

export const saveFileFromBlobStorage = async (fileDTO: FileDTO) => {
    if (!fileDTO.uri) {
        throw new Error('File Not found')
    }
    FileSaver.saveAs(fileDTO.uri, fileDTO.name)
}
